import React from "react";
import { Form, Spinner } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../../../../services/CamplaCoreService";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import BaseDatePicker from "../../../../../../components/baseDatePicker/BaseDatePicker";
import BaseSelect from "../../../../../../components/baseSelect/BaseSelect";
import "./UpdateApplicationDialog.css";

class UpdateApplicationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      name: {
        defaultValue: "",
        rule: ValidationHelper.isNonEmptyString,
      },
      expiration: {
        initValid: true,
        defaultValue: ValidationHelper.yearsFromNow(
          3
        ),
        rule: (value) => ValidationHelper.isTokenExpirationDate(value),
      },
      options: {
        defaultValue: { departmentId: "", instanceTemplateId: "" },
        initValid: true,
        rule: (value) => ValidationHelper.isApplicationOptions(value),
      },
      type: {
        defaultValue: 1,
        rule: (value) => ValidationHelper.isIntInRange(value, 0, 1),
      },
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  componentDidUpdate(prevProps) {
  if (!prevProps.show && this.props.show) {
    const cfg = {
      name: {
        defaultValue: this.props.class.name,
        rule: ValidationHelper.isNonEmptyString,
      },
      expiration: {
        defaultValue: new Date(this.props.class.expiration),
        rule: (v) => ValidationHelper.isTokenExpirationDate(v),
      },
      options: {
        defaultValue: {
          departmentId: this.props.class.options.departmentId,
          instanceTemplateId: this.props.class.options.instanceTemplateId,
        },
        rule: (v) => ValidationHelper.isApplicationOptions(v),
      },
      type: {
        defaultValue: 1,
        rule: (value) => ValidationHelper.isIntInRange(value, 0, 1),
      },
    };

    const v = ValidationHelper.getValidation(cfg);

    // --> "touch" all fields so rules run and _isValid becomes true
    const validated = ["name", "expiration", "options", "type"].reduce(
      (acc, key) =>
        ValidationHelper.update(
          { target: { name: key, value: v[key].value } },
          acc
        ),
      v
    );

    this.setState({ validation: validated });
  } else if (prevProps.show && !this.props.show) {
    this.setState({
      validation: ValidationHelper.getValidation(this.validationDefinition),
    });
  }
}


  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    });
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("Organisation.ApplicationTabbar.UpdateApplicationDialog.Title")}
        dialogApiError={this.props.dialogApiError}
        rightButtonText={t("Organisation.ApplicationTabbar.UpdateApplicationDialog.Submit")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonText={t("Organisation.ApplicationTabbar.UpdateApplicationDialog.Cancel")}
        leftButtonCallback={this.onHide}
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <div style={this.props.isUpdating ? { textAlign: "center" } : {}}>
            {this.props.isUpdating ? (
              <Spinner animation="border" />
            ) : (
              <Form>
                <Form.Group controlId="formClassName">
                  <Form.Label>{t("Organisation.ApplicationTabbar.UpdateApplicationDialog.Name")}</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder={t(
                      "Organisation.ApplicationTabbar.UpdateApplicationDialog.NamePlaceholder"
                    )}
                    value={this.state.validation.name.value}
                    isInvalid={!this.state.validation.name.isValid}
                    onChange={this.handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("Organisation.ApplicationTabbar.UpdateApplicationDialog.ValidationError.Name")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formDateEnd">
                  <Form.Label>{t("Organisation.ApplicationTabbar.UpdateApplicationDialog.Expiration")}</Form.Label>
                  <div>
                    <BaseDatePicker
                      name="end"
                      className="form-control"
                      onChange={(d) => {
                        this.handleChange({
                          target: {
                            name: "expiration",
                            value: d,
                          },
                        });
                      }}
                      value={this.state.validation.expiration.value}
                      min={new Date()}
                    />
                  </div>
                  <Form.Control
                    type="hidden"
                    isInvalid={!this.state.validation.expiration.isValid}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("Organisation.ApplicationTabbar.UpdateApplicationDialog.ValidationError.Expiration")}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group controlId="formSelectModuleClass">
                  <Form.Label>{t("Organisation.ApplicationTabbar.UpdateApplicationDialog.Departments")}</Form.Label>
                  <BaseSelect
                    isInvalid={
                      !true /* this.state.validation.options.departmentId.isValid */
                    }
                    options={this.props.departments}
                    placeholder={t(
                      "Examinations.CreateExamModal.Form.ModuleClassPlaceholder"
                    )}
                    isMulti={false}
                    onChange={(opt) => {
                      const next = {
                        ...this.state.validation.options.value,
                        departmentId: opt ? opt._id : "",
                      };
                      this.handleChange({
                        target: { name: "options", value: next },
                      });
                    }}
                    defaultValue={
                      this.props.departments
                        ? this.props.departments.find(
                            (n) =>
                              n._id === this.props?.class?.options.departmentId
                          )
                        : []
                    }
                    getOptionLabel={(option) =>
                      this.props.getLanguage(option.description)
                    }
                    getOptionValue={(option) => option._id}
                  />
                  <Form.Control
                    type="hidden"
                    isInvalid={
                      false
                    }
                  />
                </Form.Group>

                <Form.Group controlId="formSelectModuleClass">
                  <Form.Label>{t("Organisation.ApplicationTabbar.UpdateApplicationDialog.InstanceTemplate")}</Form.Label>
                  <BaseSelect
                    isInvalid={
                      !true /* this.state.validation.options.departmentId.isValid */
                    }
                    options={this.props.instanceTemplates}
                    placeholder={t(
                      "Examinations.CreateExamModal.Form.ModuleClassPlaceholder"
                    )}
                    isMulti={false}
                    onChange={(opt) => {
                      const next = {
                        ...this.state.validation.options.value,
                        instanceTemplateId: opt ? opt._id : "",
                      };
                      this.handleChange({
                        target: { name: "options", value: next },
                      });
                    }}
                    defaultValue={
                      this.props.instanceTemplates
                        ? this.props.instanceTemplates.find(
                            (n) =>
                              n._id === this.props?.class?.options.instanceTemplateId
                          )
                        : []
                    }
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option._id}
                  />
                  <Form.Control
                    type="hidden"
                    isInvalid={
                      false 
                    }
                  />
                </Form.Group>
              </Form>
            )}
          </div>
        }
      />
    );
  }
}

export default withTranslation()(UpdateApplicationDialog);
